import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=4025c99c&scoped=true"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"
import style0 from "./PaymentButton.vue?vue&type=style&index=0&id=4025c99c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025c99c",
  null
  
)

export default component.exports